import {
  SsoContainer,
  SsoItemsContainer,
  SsoSelectionTitle,
  Skeleton,
  MobileHeaderContainer,
  SsoMobileSelectionTitle,
  SsoMobileBackButton
} from './styled-components.js'
import logo from '@images/logo.svg'
import { useIdpListQuery } from '../../../../react-query/authentication/queries/use-idp-list-query.jsx'
import { SsoItem } from './sso-item.jsx'
import ButtonComponent from '../../../../components/stories/atoms/button/index.jsx'
import { FormattedMessage } from 'react-intl'
import {
  buttonSizeOptions,
  buttonVariantOptions
} from '../../../../components/stories/atoms/button/constants.js'
import { skeletonLoading } from '../../../../components/stories/organisms/context-menu/constants.js'
import { useIsMobile } from '../../../../zustand/browser-store/use-browser-store.jsx'
import { ChevronLeft } from '../../../../components/stories/atoms/icons/essentials/index.js'

const SsoLayout = ({ children, showBackButton = false, isMobile }) => {
  return (
    <SsoContainer>
      {isMobile ? <MobileHeader /> : <DesktopHeader />}
      {children}
      {showBackButton && (
        <ButtonComponent
          variant={buttonVariantOptions['TERTIARY-HOLLOW']}
          size={buttonSizeOptions.MEDIUM}
          as="a"
          to="/"
          fullWidth={isMobile}
        >
          <FormattedMessage id={'back_to_login'} />
        </ButtonComponent>
      )}
    </SsoContainer>
  )
}

const DesktopHeader = () => {
  return (
    <>
      <div>
        <img src={logo} alt="docu tools" />
      </div>
      <SsoSelectionTitle>Single Sign-on (SSO)</SsoSelectionTitle>
    </>
  )
}

const MobileHeader = () => {
  return (
    <MobileHeaderContainer>
      <ButtonComponent
        variant={buttonVariantOptions.GHOST}
        size={buttonSizeOptions.MEDIUM}
        as="a"
        to="/"
        style={{ padding: '0.5rem' }}
      >
        <SsoMobileBackButton>
          <ChevronLeft style={{ width: '16px' }} strokeWidth={3} />
          <FormattedMessage id={'back'} />
        </SsoMobileBackButton>
      </ButtonComponent>

      <SsoMobileSelectionTitle>Single Sign-on</SsoMobileSelectionTitle>
    </MobileHeaderContainer>
  )
}

const LoadingContent = () => (
  <SsoItemsContainer>
    {Array.from({ length: 9 }, (_, index) => (
      <Skeleton key={index} {...skeletonLoading} />
    ))}
  </SsoItemsContainer>
)

const LoadedContent = ({ data }) => (
  <SsoItemsContainer>
    {data.map((item, index) => (
      <SsoItem title={item.name} logo={item.logo} key={index} url={item.url} />
    ))}
  </SsoItemsContainer>
)

export const SsoSelection = () => {
  const isMobile = useIsMobile()
  const { data, isLoading } = useIdpListQuery()

  if (!data && !isLoading) {
    return null
  }

  return (
    <SsoLayout showBackButton={!isLoading && !isMobile} isMobile={isMobile}>
      {isLoading ? <LoadingContent /> : <LoadedContent data={data} />}
    </SsoLayout>
  )
}
